module.exports = __webpack_public_path__ + "static/media/021ty@3x.ef3aa144.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/021ty@3x.png
// module id = 1672
// module chunks = 0 1